<template>
  <b-card>
    <div class="d-flex mb-2">
      <div class="mr-auto"></div>
      <div>
        <b-button @click="addItem" size="sm" variant="exitos"
          >Adicionar Campo</b-button
        >
      </div>
    </div>

    <b-table-simple
      striped
      hover
      :fields="fields"
      show-empty
      class="table-campos-dinamicos"
    >
      <b-thead>
        <b-tr>
          <b-th class="col-1">#</b-th>
          <b-th>Label</b-th>
          <b-th>Valor</b-th>
          <b-th class="col-1">#</b-th>
        </b-tr>
      </b-thead>

      <b-tr v-if="!local_value.length">
        <b-td colspan="4" class="text-center"
          ><b-button @click="addItem" size="sm" variant="exitos"
            >Adicionar Campo</b-button
          ></b-td
        >
      </b-tr>
      <draggable v-model="local_value" tag="tbody" handle=".handle" v-else>
        <b-tr v-for="(item, key) in local_value" :key="key">
          <b-td class="handle">
            <font-awesome-icon icon="fas fa-ellipsis-v" />
          </b-td>
          <b-td class="td-input"><b-form-input v-model="item.label" /></b-td>
          <b-td class="td-input"><b-form-input v-model="item.valor" /></b-td>
          <b-td class="td-input pt-2">
            <Actions
              :item="item"
              :view_show="false"
              :view_edit="false"
              :view_delete="true"
              @delete="delete_value(key)"
            />
          </b-td>
        </b-tr>
      </draggable>
    </b-table-simple>
  </b-card>
</template>

<script>
import draggable from "vuedraggable";
import Actions from "@/components/Table/Actions.vue";
import _ from "lodash";
import { slugify } from "@/helpers/functions/slugify.js";

export default {
  components: { Actions, draggable },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    local_value: [],
    num_add: 0,
  }),
  computed: {
    value_data() {
      let value = [];
      _.forIn(this.local_value, function (element) {
        value.push({
          label: element.label,
          valor: element.valor,
        });
      });
      return value;
    },
    fields() {
      return [
        { key: "dragable", label: "#", class: "col-1" },
        { key: "label", label: "Label", class: "td-input" },
        { key: "valor", label: "Valor", class: "td-input" },
        { key: "actions", label: "", class: "td-input pt-2" },
      ];
    },
  },
  methods: {
    addItem() {
      this.num_add++;
      this.local_value.push({
        label: "Novo Campo " + this.num_add.toString().padStart(2, "0"),
        valor: "",
      });
    },
    delete_value(index) {
      this.local_value.splice(index, 1);
    },
  },
  watch: {
    local_value: {
      deep: true,
      handler: function (new_value) {
        let emit_value = {};
        new_value.forEach((element, key) => {
          let index = element.label ? slugify(element.label) : "campo-" + key;
          emit_value[index] = element;
        });
        this.$emit("input", emit_value);
      },
    },
    value: function (value) {
      let values = _.values(value);
      let diff = _.difference(values, this.local_value);

      if (diff.length > 0) {
        this.local_value = values;
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" >
.table-campos-dinamicos {
  .handle {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }
  .td-input {
    padding-top: 0.3rem;
    padding-bottom: 0;
  }
}
</style>
